import { render, staticRenderFns } from "./FeriadoList.vue?vue&type=template&id=9944d150&scoped=true"
import script from "./FeriadoList.vue?vue&type=script&lang=js"
export * from "./FeriadoList.vue?vue&type=script&lang=js"
import style0 from "./FeriadoList.vue?vue&type=style&index=0&id=9944d150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9944d150",
  null
  
)

export default component.exports